<div *ngIf="lexbeCase">
  <h2 mat-dialog-title>Case Configurations: {{lexbeCase?.caseName}}</h2>
  <mat-dialog-content>
    <div *ngIf="caseConfigs">
      <lex-config *ngIf="caseConfigs.length !== 0" [configs]="caseConfigs" (updatedConfig)="saveConfig($event)"></lex-config>
      <div *ngIf="caseConfigs.length === 0">
        Access Denied
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
    <button mat-raised-button color="secondary" mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
